import { Calendar } from '@fullcalendar/core';
import dayGridPlugin from '@fullcalendar/daygrid';

class CalendarController {
    constructor($element, $timeout) {
        this.$element = $element;
        this.$timeout = $timeout;
    }

    $onInit() {
        if (!this.events) {
            this.events = [];
        }
    }

    $postLink() {
        this.$timeout(() => {
            const el = this.$element[0].querySelector('.calendar-container');

            this.calendar = new Calendar(el, {
                plugins: [dayGridPlugin],
                initialView: 'dayGridMonth',
                events: this.events,
                eventContent: (info) => {
                    const wrapper = document.createElement('div');
                    wrapper.style.whiteSpace = 'normal';
                    wrapper.style.lineHeight = '1.2';

                    const titleEl = document.createElement('div');
                    titleEl.textContent = info.event.title;
                    titleEl.style.fontWeight = '600';
                    wrapper.appendChild(titleEl);

                    const comment = info.event.extendedProps && info.event.extendedProps.comment;
                    if (comment) {
                        const commentEl = document.createElement('div');
                        commentEl.textContent = comment;
                        commentEl.style.fontSize = '11px';
                        wrapper.appendChild(commentEl);
                    }

                    return { domNodes: [wrapper] };
                },
                eventDidMount: (info) => {
                    const comment = info.event.extendedProps && info.event.extendedProps.comment;
                    if (!comment) return;

                    const tooltip = `${info.event.title}\n${comment}`;
                    info.el.setAttribute('title', tooltip);
                    info.el.setAttribute('aria-label', tooltip);
                },

                eventClick: (info) => {
                    if (this.onEventClick) {
                        this.onEventClick({ $event: info.event });
                    }
                }
            });

            this.calendar.render();
        });
    }

    $onChanges(changes) {
        if (changes.events && this.calendar) {
            this.calendar.removeAllEvents();
            this.calendar.addEventSource(this.events || []);
        }
    }
}

CalendarController.$inject = ['$element', '$timeout'];

export const calendar = {
    bindings: {
        events: '<',
        onEventClick: '&'
    },
    controller: CalendarController,
    template: require('./calendar.html')
};
